import 'Utils/mere.js';
//import 'Modules/map-container';
//import { InitializeMapDestinations } from 'SrcJS/maps/mapbox-custom';

import { hasMapDestinations, MapDestinationsElement } from 'SrcJS/maps/mapbox-custom--dependencies';
import { LazyInitializer } from 'Utils/LazyInitializer';

var hasMapDestinationsDependencies = hasMapDestinations();
var InitializeMapDestinations = undefined;
async function getComponent_MapDestinations() {
    await import('Modules/map-container');
    const { InitializeMapDestinations } = await import('SrcJS/maps/mapbox-custom');
    console.log('>>> loaded: SrcJS/maps/mapbox-custom');
    return { InitializeMapDestinations };
}

AppLoader.ready(async function () {
    //InitializeMapDestinations();
    if (hasMapDestinationsDependencies) {
        let init_map = async function () {
            if (typeof InitializeMapDestinations == "undefined") {
                InitializeMapDestinations = (await getComponent_MapDestinations()).InitializeMapDestinations;
            }
            InitializeMapDestinations();
            return true;
        }
        
        let mapElement = MapDestinationsElement();
        let lazyInitializer = new LazyInitializer(mapElement, init_map);
        //lazyInitializer.init().then((result) => {
        //    console.log('>>> lazyInitializer >> InitializeMapDestinations done', result);
        //});
        lazyInitializer.init();
    }
});